// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
   production: true,
   /*
   This is only used and configured for local development in oder to bypass the ASP Core shell.
   This must be kept in sync while the asp core configuration evolves.
   */
   clientConfiguration: {
      msalConfig: {
         authTenant: 'ridderb2c.onmicrosoft.com',
         clientId: '07aab67f-eb87-4bed-9fd7-ac5be4317939',
         validateAuthority: false,
         navigateToLoginRequestUrl: false,
         scopes: ['https://ridderb2c.onmicrosoft.com/RidderConnectAPI/Read'],
         defaultUserAuthSettings: {
            signinPolicy: 'B2C_1_Hortos_Signin',
            signupPolicy: 'B2C_1_Hortos_Signup',
            resetPasswordPolicy: 'B2C_1_Hortos_PasswordReset',
            loginUrl: 'https://ridderb2c.b2clogin.com/',
         },
         ridderUserAuthSettings: {
            signinPolicy: 'B2C_1A_signup_signin',
            loginUrl: 'https://ridderb2c.b2clogin.com/',
            extraQueryParameters: { ui_locales: 'nl', domain_hint: 'Ridder' }
         }
      },
      environment: '',
      googleAnalyticsMeasurementId: '',
      handsonLicenseKey: '90b54-410a6-04a43-9492c-0eb2d',
      devextremeLicenseKey: '',

      // LOCAL:
      organizationsApiBaseUrl: 'http://localhost:47206/api',
      resourceApiBaseUrl: 'http://localhost:47205/api',
      translationsApiBaseUrl: 'http://localhost:47200/api',
      socialApiBaseUrl: 'http://localhost:47204/api',
      platformAdministrationApiBaseUrl: "http://localhost:47201/api"

      // DEV:
      //organizationsApiBaseUrl: 'https://dev.hortos.ridder.com/internal/api/organization',
      //resourceApiBaseUrl: 'https://dev.hortos.ridder.com/internal/api/resources',
      //socialApiBaseUrl: 'https://dev.hortos.ridder.com/internal/api/social',
      //translationsApiBaseUrl: 'https://dev.hortos.ridder.com/internal/api/translations',
      //platformAdministrationApiBaseUrl: "https://dev.hortos.ridder.com/internal/api/platformadmin"

      // TEST:
      //organizationsApiBaseUrl: 'https://test.hortos.ridder.com/internal/api/organization',
      //resourceApiBaseUrl: 'https://test.hortos.ridder.com/internal/api/resources',
      //socialApiBaseUrl: 'https://test.hortos.ridder.com/internal/api/social',
      //translationsApiBaseUrl: 'https://test.hortos.ridder.com/internal/api/translations',
      //platformAdministrationApiBaseUrl: "https://test.hortos.ridder.com/internal/api/platformadmin"

      // PROD:
      //organizationsApiBaseUrl: 'https://hortos.ridder.com/internal/api/organization',
      //resourceApiBaseUrl: 'https://hortos.ridder.com/internal/api/resources',
      //socialApiBaseUrl: 'https://hortos.ridder.com/internal/api/social',
      //translationsApiBaseUrl: 'https://hortos.ridder.com/internal/api/translations',
      //platformAdministrationApiBaseUrl: "https://hortos.ridder.com/internal/api/platformadmin"
   }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
